import SortPopup, { SortOption } from "../../../../components/sort_popup/sort_popup";

// The applications list can only safely sort by its own createdAt/updatedAt
// columns - anything else (e.g. applicant name) lives on an associated
// table and would need Sequelize's association-qualified order syntax,
// which admin-jobs-service's getJobApplicationsList doesn't support.
export type JobApplicationSortOption = "newest" | "oldest";

export const DEFAULT_JOB_APPLICATION_SORT_OPTION: JobApplicationSortOption = "newest";

const OPTIONS: SortOption<JobApplicationSortOption>[] = [
  { value: "newest", label: "New to old" },
  { value: "oldest", label: "Old to new" },
];

export function jobApplicationSortOptionLabel(option: JobApplicationSortOption): string {
  return OPTIONS.find((o) => o.value === option)!.label;
}

export function jobApplicationSortOptionToParams(option: JobApplicationSortOption): {
  sortBy: "createdAt";
  sortOrder: "ASC" | "DESC";
} {
  return { sortBy: "createdAt", sortOrder: option === "oldest" ? "ASC" : "DESC" };
}

export default function SortJobApplicationPopup({
  open,
  onClose,
  sortOption,
  setSortOption,
}: {
  open: boolean;
  onClose: () => void;
  sortOption: JobApplicationSortOption;
  setSortOption: (option: JobApplicationSortOption) => void;
}) {
  return (
    <SortPopup
      open={open}
      onClose={onClose}
      title="Sort Job Applications"
      options={OPTIONS}
      value={sortOption}
      onApply={setSortOption}
    />
  );
}
